import { useSelector } from 'react-redux';
import './MainText.css';
import { selectAllUrlParams } from '../../store/slices/urlParamsSlice';
import { selectAllImages, selectAllVideos } from '../../store/slices/uploadedContentSlice';
import {
  getFontFamilyStyle,
  getFontSizeStyle,
  getTextEffectStyles,
} from '../../utils/eventStyling';

function MainText() {
  const event = useSelector(selectAllUrlParams);
  const images = useSelector(selectAllImages);
  const videos = useSelector(selectAllVideos);
  const hasUploads = images.length > 0 || videos.length > 0;
  const theme = event?.templateId || event?.theme || 'event';
  const isRestaurantTheme = theme === 'restaurant';

  const titleBaseFamily = isRestaurantTheme
    ? "'Poppins', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    : "'Playfair Display', 'Cormorant Garamond', Georgia, 'Times New Roman', Times, serif";

  const subtitleBaseFamily = isRestaurantTheme
    ? "'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif"
    : "'Cormorant Garamond', 'Playfair Display', Georgia, serif";

  const titleStyle = {
    color: event?.titleTextColor,
    fontFamily: getFontFamilyStyle(event?.titleFontFamily, titleBaseFamily),
    fontSize: getFontSizeStyle(event?.titleFontSize, 48),
    ...getTextEffectStyles(event?.titleTextEffect, event?.titleTextEffectColor),
  };

  const subtitleStyle = {
    color: event?.subtitleTextColor || event?.mainTextColor,
    fontFamily: getFontFamilyStyle(event?.subtitleFontFamily, subtitleBaseFamily),
    fontSize: getFontSizeStyle(event?.subtitleFontSize, 20),
    ...getTextEffectStyles(
      event?.subtitleTextEffect || event?.mainTextEffect,
      event?.subtitleTextEffectColor
    ),
  };

  const dateStyle = {
    color: event?.subtitleTextColor || event?.mainTextColor,
    ...getTextEffectStyles(
      event?.subtitleTextEffect || event?.mainTextEffect,
      event?.subtitleTextEffectColor
    ),
  };
  
  return (
    <div className={`container1 ${!hasUploads ? 'no-uploads' : ''} theme-${theme}`}>
       <p className={`text1 ${isRestaurantTheme ? 'restaurant-title' : 'event-title'}`} style={titleStyle}>{event?.eventName}</p>
       {!isRestaurantTheme && event?.eventDate && (
         <p className={`text2 ${isRestaurantTheme ? 'restaurant-date' : 'event-date'}`} style={dateStyle}>{event?.eventDate}</p>
       )}
       {event?.mainText && (
         <p className={`text3 ${isRestaurantTheme ? 'restaurant-message' : 'event-message'}`} style={subtitleStyle}>{event?.mainText}</p>
       )}
    </div>
  );
}

export default MainText;
